var isProd = ($.trim(process.env.NODE_ENV) == 'production');
var isStaging = ($.trim(process.env.NODE_ENV) == 'staging');
var isDev = ($.trim(process.env.NODE_ENV) == 'develop');
var isDemo = ($.trim(process.env.NODE_ENV) == 'demo');

var config = {
    VERSION: '1.27.0',
    BASE_URL: '',
    BASE_AUTH_URL: '',
    API_URL: '',
    AUTH_API_URL: '',
    AUTH_LOGIN_URL: '',
    AUTH_LOGOUT_URL: '',
    AUTH_CLIENT_ID: '',
    AUTH_SCOPES: '',
}

config.AUTH_CLIENT_ID = 'js';
config.AUTH_SCOPES = 'openid profile api';

if (isProd) {

    config.BASE_URL = 'https://operando-api.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth.tccapps.nl/';

} else if (isStaging) {

    config.BASE_URL = 'https://operando-api-staging.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-staging.tccapps.nl/';

} else if (isDev) {

    config.BASE_URL = 'https://operando-api-develop.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-develop.tccapps.nl/';

} else {


   // config.BASE_URL = 'http://operando-api-develop.tccapps.nl/';
    config.BASE_AUTH_URL = 'https://operando-auth-develop.tccapps.nl/';
    config.BASE_URL = 'http://localhost:5000/';
    //https://operando-auth-develop.tccapps.nl/config.BASE_AUTH_URL = 'https://operando-auth-develop.azurewebsites.net/';
}

config.API_URL = config.BASE_URL + 'api/';
config.AUTH_API_URL = config.BASE_AUTH_URL + 'auth/';
config.AUTH_LOGIN_URL = config.BASE_AUTH_URL + 'connect/authorize';
config.AUTH_LOGOUT_URL = config.BASE_AUTH_URL + 'connect/endsession';

export default config;


// WEBPACK FOOTER //
// ./src/app/config.ts